'use client';

import React from 'react';

interface DiscordLinkProps {
  children: React.ReactNode;
  className?: string;
}

const DiscordLink: React.FC<DiscordLinkProps> = ({ children, className = "" }) => {
  const handleDiscordClick = () => {
    window.open('https://discord.gg/Vn2JpusbXX', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={className} onClick={handleDiscordClick}>
      {children}
    </div>
  );
};

export default DiscordLink;
